if (!customElements.get("td-pdp-side-drawer")) {
  class TdPdpSideDrawer extends HTMLElement {
    constructor() {
      super();
      this.titleButtons = this.querySelectorAll("[data-side-drawer]");
      this.body = document.querySelector("body");
      this.overlayClass = "td-sd__overlay";
    }

    connectedCallback() {
      this.initSideDrawer();
    }

    initSideDrawer() {
      this.titleButtons.forEach((title) => {
        title.addEventListener("click", (event) => {
          const drawerNumber = title.dataset.sideDrawer;
          const contentWrapper = this.querySelector(
            `[data-side-drawer-${drawerNumber}-wrapper]`
          );

          this.querySelectorAll(".td-sd__content-wrapper--active").forEach((openWrapper) => {
            if (openWrapper !== contentWrapper) {
              openWrapper.classList.remove("td-sd__content-wrapper--active");
            }
          });

          if (contentWrapper) {
            const isActive = contentWrapper.classList.contains("td-sd__content-wrapper--active");

            if (isActive) {
              this.closeDrawer(contentWrapper);
            } else {
              this.openDrawer(contentWrapper);
            }
          }
        });
      });

      const closeButtons = this.querySelectorAll(".td-sd__close");
      closeButtons.forEach((closeButton) => {
        closeButton.addEventListener("click", (event) => {
          const contentWrapper = closeButton.closest(".td-sd__content-wrapper");
          if (contentWrapper) {
            this.closeDrawer(contentWrapper);
          }
          event.stopPropagation(); // Prevents the click from bubbling to the body
        });
      });

      // Listen to the body click to close the drawer when clicking outside
      this.body.addEventListener("click", (event) => {
        if (event.target === this.body && this.body.classList.contains(this.overlayClass)) {
          const contentWrapper = this.querySelector(".td-sd__content-wrapper--active");
          
          if (contentWrapper) {
            this.closeDrawer(contentWrapper);
          }
        }
      });
      
    }

    openDrawer(contentWrapper) {
      if (this.body) {
        this.body.classList.add(this.overlayClass);
      }

      contentWrapper.classList.add("td-sd__content-wrapper--active");
    }

    closeDrawer(contentWrapper) {
      contentWrapper.classList.remove("td-sd__content-wrapper--active");

      if (!this.querySelector(".td-sd__content-wrapper--active") && this.body) {
        this.body.classList.remove(this.overlayClass);
      }
    }

    closeAllDrawers() {
      this.querySelectorAll(".td-sd__content-wrapper--active").forEach((openWrapper) => {
        openWrapper.classList.remove("td-sd__content-wrapper--active");
      });

      if (this.body) {
        this.body.classList.remove(this.overlayClass);
      }
    }
  }

  customElements.define("td-pdp-side-drawer", TdPdpSideDrawer);
}
